import React, { Component } from 'react'; //different
import MainSettingContext from './MainSettingContext';
//import Paoyingchub from './game/paoyingchub';
import instance from "./axios-instance";
//import './build/web/igame-index-lobby-wm/style.a57427aa.css';
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import moment from 'moment';
class App extends Component {
    static contextType = MainSettingContext;

    constructor(props) {
        super(props)
        this.state = {
            userid: props.userid,   // only pick what you need
            tabselect: 0,
            point: props.point || 0,
            cardSetting: [],
            historylist: [],
            CardListSelect: null,
            CardGameData: [],
            cards: Array.from({ length: 5 }, (_, index) => ({
                cardopen: false,
                loader: false,
                image: null,
                keyid: index,  // ตั้งค่า keyid เป็น index หรือค่าที่คุณต้องการ
            })),
        }

    }
    handleNav(to, e = { preventDefault: () => { } }) {
        // ถ้า e ถูกส่งมาจาก onClick ปกติ
        if (e?.preventDefault) e.preventDefault();

        // รองรับ ctrl / alt / middle click
        if (e?.metaKey || e?.ctrlKey || e?.shiftKey || e?.altKey || e?.button === 1) return;

        console.log("📍 Navigate to:", to);

        if (typeof this.props.onNavigate === "function") {
            this.props.onNavigate(to, e);
        } else {
            // fallback
            window.history.pushState(null, "", to);
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    }

    // ถ้ parent อาจได้รับ userid ทีหลัง
    componentDidUpdate(prevProps, prevState) {
        const { point, userid } = this.props; // destructuring for easier access

        // Check if point has changed
        if (prevProps.point !== point) {
            if (point !== this.state.point) {
                console.log("componentDidUpdate - point updated:", point);
                this.setState({ point });
            }
        }

        // Check if username has changed
        if (prevProps.userid !== userid) {
            if (userid !== this.state.userid) {
                console.log("componentDidUpdate - username updated:", userid);
                this.setState({ userid: userid });
            }
        }
    }

    async componentDidMount() {
        console.log("componentDidMount Cardgame prevState", this.props);
        await this.getcard();
    }
    // componentDidUpdate(prevProps) {
    //     // ถ้าต้องการซิงค์เมื่อ parent เปลี่ยน userid
    //     if (prevProps.userid !== this.props.userid) {
    //         this.setState({ userid: this.props.userid || "" });
    //     }
    // }
    getcard = async () => {
        // var segments = [{ id: 1, name: '5 บาท' }, { id: 2, name: '100 บาท' }, { id: 3, name: '300 บาท' }, { id: 4, name: '10 บาท' }, { id: 5, name: '20 บาท' }, { id: 6, name: 'คร้งหน้านะ บาท' }, { id: 7, name: 'เกือบได้แล้ว' }, { id: 8, name: 'ครั้งหน้านะ' }, { id: 9, name: '1000 บาท' }];
        try {
            await instance.post("/api/v1/getcardminigame", {
                System: Systems,
                userid: this.state.userid,
            }).then(async (res) => {
                console.log("getgetcard", res.data)
                if (res.data.status === 200) {
                    const datas = res.data;
                    if (datas.tblcardminigamesetting.length > 0 && datas.tblcardminigamesetting[0].status == 0) {
                        await Swal.fire({
                            icon: 'error',
                            title: 'เกมยังไม่เปิดให้บริการ',
                            showConfirmButton: true,
                            confirmButtonText: 'ตกลง'
                        });
                        this.handleNav('/event')
                    }

                    this.setState({
                        cardSetting: datas.tblcardminigamesetting,
                        CardGameData: datas.message,
                        historylist: datas.historylist,
                    });

                }
                else {
                    // this.CheckThisGoalError();
                }
            });
        }
        catch (error) {
            console.log(error)
        }

    }

    postCardRandom = async () => {
        // var segments = [{ id: 1, name: '5 บาท' }, { id: 2, name: '100 บาท' }, { id: 3, name: '300 บาท' }, { id: 4, name: '10 บาท' }, { id: 5, name: '20 บาท' }, { id: 6, name: 'คร้งหน้านะ บาท' }, { id: 7, name: 'เกือบได้แล้ว' }, { id: 8, name: 'ครั้งหน้านะ' }, { id: 9, name: '1000 บาท' }];
        try {
            return await instance.post("/api/v1/postcardminigame", {
                System: Systems,
                token: localStorage.getItem('auth_token'),
                cardlistid: this.state.CardListSelect.id,
            }).then((res) => {
                console.log("/api/v1/postcardminigame", res)
                if (res.data.status === 200) {
                    this.setState({ point: res.data.event_balance })
                    return res.data;
                }
                else if (res.data.status === 201) {
                    Swal.fire({
                        icon: 'error',
                        title: 'คุณเปิดไพ่ครบแล้วในวันนี้ กรุณารอวันใหม่',
                        showConfirmButton: true,
                        confirmButtonText: 'ตกลง'
                    });
                    this.onClicknewDraw(this.state.cards.length);
                    return null;

                }
                else {
                    return null;
                }
            });
        }
        catch (error) {
            console.log(error)
            return null
        }

    }

    onClickCardGame = async (index) => {

        const cards = [...this.state.cards];  // ทำสำเนาของ cards
        if (this.state.point <= 0) {
            await Swal.fire({
                icon: 'error',
                title: 'แต้มไม่พอในเล่นเกมนี้',
                showConfirmButton: true,
                confirmButtonText: 'ตกลง'
            });
            await this.onClicknewDraw(cards.length);
            return;
        }
        if (this.state.loginstate == false) {
            await Swal.fire({
                icon: 'error',
                title: 'กรุณาเข้าสู่ระบบก่อนเล่น',
                showConfirmButton: true,
                confirmButtonText: 'ตกลง'
            });
            await this.onClicknewDraw(cards.length);
            return;
        }
        if (this.state.CardListSelect == null) {
            await Swal.fire({
                icon: 'error',
                title: 'กรุณาเลือกกิจกรรมก่อนเล่น',
                showConfirmButton: true,
                confirmButtonText: 'ตกลง'
            });
            await this.onClicknewDraw(cards.length);
            return;
        }
        if (this.state.cards.some(card => card.cardopen)) {
            await Swal.fire({
                icon: 'warning',
                title: 'ทางเราจะ reset ไพ่ให้ใหม่',
                text: 'กรุณากดปุ่ม "ตกลง" เพื่อทำการสุ่มใหม่',
                showCancelButton: true,            // ถ้าต้องการให้มีปุ่มยกเลิกด้วย
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            });
            await this.onClicknewDraw(cards.length);
            return;
        }

        console.log("clickcard", cards);

        // ถ้ากำลังโหลดอยู่ ห้ามคลิก
        if (cards[index].loader) return;
        // ตั้ง loader เป็น true และ cardopen เป็น false สำหรับบัตรที่ถูกคลิก
        cards[index].loader = true;

        // // อัพเดท state ของบัตรที่ถูกคลิก
        this.setState({ cards });
        console.log("clickcard", index);
        const winner = await this.postCardRandom();
        if (winner == null) {
            cards[index].loader = false;
            this.setState({ cards });
            return;
        }

        console.log("clickcard winner", winner);
        cards[index].image = winner.reward.image;
        cards[index].cardopen = true;
        cards[index].loader = false;
        this.setState({ cards });
    };

    onClicknewDraw = async (number) => {
        console.log("onClicknewDraw", number);
        this.setState({
            cards: Array.from({ length: number }, (_, index) => ({
                cardopen: false,
                loader: false,
                image: null,
                keyid: index,  // ตั้งค่า keyid เป็น index หรือค่าที่คุณต้องการ
            })),
        });

        // หน่วงเวลา 3 วินาที ก่อนจะสุ่มรูป        
    }

    oncliekOpenTab(e, tab, Item) {
        console.log("oncliekOpenTab", tab, Item);
        const cards = Array.from({ length: Item.totalcard }, (_, index) => ({
            cardopen: false,
            loader: false,
            image: null,
            keyid: index,  // ตั้งค่า keyid เป็น index หรือค่าที่คุณต้องการ
        }));

        this.setState({ tabselect: tab, cards: cards, CardListSelect: Item });
    }

    render() {
        const { tabselect, loader, historylist, cards, cardSetting, CardListSelect } = this.state;
        console.log("Current historylist:", CardListSelect); // ดีบัก state ปัจจุบัน
        return (
            <>
                <br></br>
                <br></br>
                <br></br>
                <div className="animated animatedFadeInUp fadeInUp mt-2">
                    <div className="row m-0 border-shadow-title" style={{ display: tabselect == 0 ? "" : "none" }}>
                        <div className="col-11 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                            <div className="text-center bg-title-web" style={{ paddingTop: 50 }}>
                                <div>
                                    <div className="text-title text-white-v1 text-center">
                                        <div className="d-flex justify-content-between">
                                            <div className="text-white-v1-deposit">
                                                <a role="button" onClick={() => this.handleNav('/')}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={25}
                                                        height={25}
                                                        fill="currentColor"
                                                        className="bi bi-arrow-left-circle text-color-back"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                                                        />
                                                    </svg>
                                                </a>
                                            </div>
                                            <div className="text-white-v1-deposit">
                                                <h5>กิจกรรมเปิดไพ่</h5>
                                            </div>
                                            <div>
                                                <div className="text-white-v1-deposit">
                                                    <h5 role="button" onClick={(e) => {
                                                        this.setState({ tabselect: 2 });
                                                    }} className="text-title-navbar">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={20}
                                                            height={20}
                                                            fill="currentColor"
                                                            className="text-white-v1-deposit bi bi-card-list"
                                                            viewBox="0 0 16 16"
                                                        >
                                                            <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
                                                            <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
                                                        </svg>
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="mt-0" />
                                    </div>
                                </div>
                            </div>
                            <div className="tab text-white-v1 bg-profile-box-overview-card-game p-2 mt-2 mb-2">
                                <button className={this.state.point > 0 ? "btn -btn-spin js-wheel-button animated fadeInUp" : "btn -btn-spin js-wheel-button disabled animated fadeInUp"} data-animatable="fadeInUp" data-delay={200} disabled={true}>
                                    <span className="-text ">จำนวนแต้มที่ใช้ได้</span>
                                    <span className="-text js-spin-ticket">{"  " + this.state.point || 0} แต้ม</span>
                                </button>
                                <br></br>
                                <br></br>
                                <div className="row">
                                    {cardSetting.length > 0 &&
                                        cardSetting.map((item, index) => (
                                            <div className="col-12 col-md-12 col-lg-6 p-1">
                                                <div className="row">
                                                    <div className="col-5 col-md-4">
                                                        <div className="p-0">
                                                            <img
                                                                className="w-100 img-fit-card-game img-menu-lobby"
                                                                src={item.image}
                                                                alt=""
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-7 col-md-8 align-self-center p-1">
                                                        <div className="p-0" key={index}>
                                                            <b className="text-color-username clip-title">
                                                                {item.name}
                                                            </b>
                                                            <div className="dt-full-details">
                                                                <section
                                                                    dangerouslySetInnerHTML={{ __html: item.description }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="row">
                                                    <div className="col-12 col-md-12 p-1">
                                                        <a onClick={(e) => {
                                                            this.oncliekOpenTab(e, 1, item)
                                                        }} role="button">
                                                            <div className="bg-text-highlight m-2">
                                                                <div className="p-2" role="button">
                                                                    <div className="d-flex justify-content-center">
                                                                        <div className="align-self-center" >
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width={20}
                                                                                height={20}
                                                                                fill="currentColor"
                                                                                className="bi bi-suit-spade-fill"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path d="M7.184 11.246A3.5 3.5 0 0 1 1 9c0-1.602 1.14-2.633 2.66-4.008C4.986 3.792 6.602 2.33 8 0c1.398 2.33 3.014 3.792 4.34 4.992C13.86 6.367 15 7.398 15 9a3.5 3.5 0 0 1-6.184 2.246 19.92 19.92 0 0 0 1.582 2.907c.231.35-.02.847-.438.847H6.04c-.419 0-.67-.497-.438-.847a19.919 19.919 0 0 0 1.582-2.907z" />
                                                                            </svg>
                                                                        </div>
                                                                        <div className="align-self-center"  >
                                                                            {" "}
                                                                            &nbsp; เข้าเล่น
                                                                        </div>
                                                                        <div className="align-self-center" >
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width={16}
                                                                                height={16}
                                                                                fill="currentColor"
                                                                                className="bi bi-chevron-right"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path
                                                                                    fillRule="evenodd"
                                                                                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                                                                                />
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row m-0 border-shadow-title" style={{ display: tabselect == 1 ? "" : "none" }}>
                        <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                            <div className="text-center bg-title-web" style={{ paddingTop: 50 }}>
                                <div>
                                    <div className="text-title text-white-v1 text-center">
                                        <div className="d-flex justify-content-start">
                                            <div className="text-white-v1-deposit">
                                                <a role="button" onClick={(e) => {
                                                    this.setState({ tabselect: 0, CardListSelect: null });
                                                    console.log("oncliekOpenTab back to 0");
                                                }}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={25}
                                                        height={25}
                                                        fill="currentColor"
                                                        className="bi bi-arrow-left-circle text-color-back"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                                                        />
                                                    </svg>
                                                </a>
                                            </div>
                                            <div className="text-white-v1-deposit">
                                                <small className="text-color-hl">
                                                    {" "}
                                                    &nbsp; <b> กิจกรรม </b>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={10}
                                                        height={10}
                                                        fill="currentColor"
                                                        className="bi bi-chevron-right"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                                        />
                                                    </svg>{" "}
                                                    กิจกรรมเปิดไพ่{" "}
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={10}
                                                        height={10}
                                                        fill="currentColor"
                                                        className="bi bi-chevron-right"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                                        />
                                                    </svg>{" "}
                                                    {this.state.CardListSelect?.name}
                                                </small>
                                            </div>
                                            <div>{/**/}</div>
                                        </div>
                                        <hr className="mt-0" />
                                    </div>
                                </div>
                            </div>
                            <div className="auction__body-menu auction__body--border-radius">
                                <button className={this.state.point > 0 ? "btn -btn-spin js-wheel-button animated fadeInUp" : "btn -btn-spin js-wheel-button disabled animated fadeInUp"} data-animatable="fadeInUp" data-delay={200} disabled={true}>
                                    <span className="-text ">จำนวนแต้มที่ใช้ได้</span>
                                    <span className="-text js-spin-ticket">{"  " + this.state.point || 0} แต้ม</span>
                                </button>
                                <div>
                                    <div className="pt-2 pb-2 p-2">
                                        <div className="row">
                                            {this.state.cards.map((card, index) => (
                                                <div key={index} className="col-4 col-md-3 col-lg-3 p-1">
                                                    <div className="container-card">
                                                        {/* === flip wrapper แทน ternary เดิม === */}
                                                        <div className={`card-flip ${card.cardopen ? 'flipped ' : ''}`} style={{ minHeight: '1px' }}>
                                                            <div className="card-flip-inner">
                                                                {/* FRONT */}
                                                                <div className="card-flip-front" style={{ display: card.cardopen ? "none" : "" }}>
                                                                    <img
                                                                        className="p-1 pb-2 circle-card-game image-card"
                                                                        src={CardListSelect?.image}
                                                                        alt={`front-${index}`}
                                                                    />
                                                                </div>

                                                                {/* BACK */}
                                                                <div className="card-flip-back" style={{ display: !card.cardopen ? "none" : "" }}>
                                                                    <img
                                                                        className="p-1 pb-2 circle-card-game image-card"
                                                                        src={card?.image}
                                                                        alt={`back-${card.keyid ?? index}`}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* === overlay เดิม (ผมปรับเงื่อนไขการแสดงปุ่มเล็กน้อย) === */}
                                                        <div className="overlay-card" role="button">
                                                            <div className="text-card text-card-game-hover">
                                                                <h4>
                                                                    <div className="bg-text-highlight m-1">
                                                                        <div className="p-1" role="button">
                                                                            {/* ปุ่มเปิดไพ่ — แสดงเมื่อยังไม่เปิด (card.cardopen === false) */}
                                                                            <div
                                                                                onClick={(e) => { if (!card.loader && !card.cardopen) this.onClickCardGame(index); }}
                                                                                className={card.cardopen ? "justify-content-center" : "d-flex justify-content-center"}
                                                                                style={{ display: card.cardopen ? "none" : "" }}
                                                                            >
                                                                                <div className="align-self-center" style={{ display: card.loader ? "" : "none" }}>
                                                                                    <div className="text-center text-white-v1">
                                                                                        <span className="loader" />
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    role="button"
                                                                                    style={{ display: !card.loader ? "" : "none" }}
                                                                                    className="align-self-center font-open-card"
                                                                                >
                                                                                    &nbsp; เปิดไพ่
                                                                                </div>
                                                                            </div>

                                                                            {/* ข้อความหลังสุ่มเสร็จ — แสดงเมื่อเปิดแล้ว */}
                                                                            <div
                                                                                onClick={(e) => { this.onClicknewDraw(this.state.cards.length) }}
                                                                                className={card.cardopen ? "d-flex justify-content-center" : "justify-content-center"}
                                                                                style={{ display: card.cardopen ? "" : "none" }}
                                                                            >
                                                                                <div className="align-self-center" >
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="currentColor" className="bi bi-check-circle-fill text-success" viewBox="0 0 16 16">
                                                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                                                                    </svg>
                                                                                </div>
                                                                                <div className="align-self-center" style={{ color: "black", fontSize: "1.025rem" }}>
                                                                                    &nbsp; สุ่มไพ่เรียบร้อย
                                                                                </div>
                                                                                <div className="align-self-center" >
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                                                                                        <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                                                                    </svg>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </h4>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            ))}

                                        </div>
                                    </div>

                                    <div className="p-2 text-left">
                                        <section
                                            dangerouslySetInnerHTML={{ __html: CardListSelect?.description }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row m-0 border-shadow-title" style={{ display: tabselect == 2 ? "" : "none" }}>
                        <div className="row m-0 border-shadow-title">
                            <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                                <div className="text-center bg-title-web" style={{ paddingTop: 50 }}>
                                    <div>
                                        <div className="text-title text-white-v1 text-center">
                                            <div className="d-flex justify-content-between">
                                                <div className="text-white-v1-deposit" href='/'>
                                                    <a role="button" href='/'>
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={25}
                                                            height={25}
                                                            fill="currentColor"
                                                            className="bi bi-arrow-left-circle text-color-back"
                                                            viewBox="0 0 16 16"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                                                            />
                                                        </svg>
                                                    </a>
                                                </div>
                                                <div className="text-white-v1-deposit">
                                                    <h5>ประวัติการเล่นเปิดไพ่</h5>
                                                </div>
                                                <div>{/**/}</div>
                                            </div>
                                            <hr className="mt-0" />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-0 container animated animatedFadeInUp fadeInUp text-center">
                                    <div className="row m-0 text-center">
                                        <div className="col-12 p-2 text-center">
                                            <div
                                                data-v-02098bde=""
                                                data-v-28a2bed6=""
                                                className="tourneys__tabs row text-center"
                                            >
                                                <button
                                                    data-v-47c7b004=""
                                                    data-v-28a2bed6=""
                                                    type="button"
                                                    className="active button-tab button-tab_md button-tab_blue pl-3 pr-3 col-4 text-center"
                                                >
                                                    <span
                                                        data-v-47c7b004=""
                                                        data-v-28a2bed6=""
                                                        className="pl-4-pr-4"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={16}
                                                            height={16}
                                                            fill="currentColor"
                                                            className="bi bi-wallet2"
                                                            viewBox="0 0 16 16"
                                                        >
                                                            <path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484L5.562 3zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z" />
                                                        </svg>{" "}
                                                        ทั้งหมด
                                                    </span>
                                                </button>
                                            </div>
                                            <div
                                                data-v-ab1d19ba=""
                                                className="auction-list animated animatedFadeInUp fadeInUp text-white-v1"
                                            >
                                                <div style={{ display: (this.state.historylist.length === 0) ? "" : "none" }} >
                                                    <div>
                                                        <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp">
                                                            <b>
                                                                <img
                                                                    className="load-history"
                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                    alt=""
                                                                />
                                                                <div className="not-history font-history-menu-text p-2">
                                                                    <small>
                                                                        <b>ไม่พบรายการ...</b>
                                                                    </small>
                                                                </div>
                                                            </b>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    style={{ display: (this.state.historylist.length === 0) ? "none" : "" }}
                                                    data-v-ab1d19ba=""
                                                    className="auction-list animated animatedFadeInUp fadeInUp text-white-v1"
                                                >
                                                    <div data-v-0bcfa847="" data-v-ab1d19ba="">
                                                        <div data-v-0bcfa847="" className="list__head">
                                                            <span data-v-0bcfa847="">ประวัติทำรายการ </span>
                                                            <span data-v-0bcfa847="">เวลา </span>
                                                            <span data-v-0bcfa847="">จำนวนเงิน </span>
                                                        </div>
                                                        <div>
                                                            {this.state.historylist.map((listitem, i) => (
                                                                <>
                                                                    <div data-v-0bcfa847="" className="list__inner">
                                                                        <div>
                                                                            <div data-v-0bcfa847="" className="list-item">
                                                                                <div data-v-0bcfa847="" className="list-item__user">
                                                                                    <div data-v-0bcfa847="" className="item-user">
                                                                                        <div
                                                                                            data-v-b41a49a6=""
                                                                                            data-v-0bcfa847=""
                                                                                            className="user item-user__userpick user--clickable"
                                                                                        >
                                                                                            <div data-v-b41a49a6="" className="user__wrap" />
                                                                                        </div>
                                                                                        <span
                                                                                            data-v-0bcfa847=""
                                                                                            className={"item-user__betsize text-success"}                                                                                              >
                                                                                            <h5 className="m-0 font-list-history">{"เปิดไพ่"}</h5>
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                <div data-v-0bcfa847="" className="list-item__user">
                                                                                    <div data-v-0bcfa847="" className="item-user">
                                                                                        <div
                                                                                            data-v-b41a49a6=""
                                                                                            data-v-0bcfa847=""
                                                                                            className="user item-user__userpick user--clickable"
                                                                                        >
                                                                                            <div data-v-b41a49a6="" className="user__wrap" />
                                                                                        </div>
                                                                                        <span data-v-0bcfa847="" className="item-user__name">
                                                                                            {moment(listitem.dateupdate).format('DD/MM/YY') + " - " + moment(listitem.dateupdate).format('HH:mm') + " น."}
                                                                                        </span>
                                                                                        <span
                                                                                            data-v-0bcfa847=""
                                                                                            className="item-user__betsize text-success"
                                                                                        >
                                                                                            <div style={{ display: (listitem.status === "2") ? "" : "none" }}>
                                                                                                <span className="-state-text">สถานะ : </span>
                                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-counterclockwise text-warning" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"></path><path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"></path></svg>
                                                                                                {" "} <span className="-state-title text-warning">กำลังดำเนินการ</span>
                                                                                            </div>
                                                                                            <div style={{ display: (listitem.status === "0") ? "" : "none" }}>
                                                                                                <span className="-state-text">สถานะ : </span>
                                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-counterclockwise text-warning" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"></path><path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"></path></svg>
                                                                                                {" "} <span className="-state-title text-warning">รอดำเนินการ</span>
                                                                                            </div>
                                                                                            <div style={{ display: (listitem.status === "4") ? "" : "none" }}>
                                                                                                <span className="-state-text">สถานะ : </span>
                                                                                                <img
                                                                                                    src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                                                                                    className="-ic"
                                                                                                    width="16" height="16"
                                                                                                    alt=""
                                                                                                />
                                                                                                {" "}
                                                                                                <span className="-state-title">ยกเลิก (ยกเลิกโดยผู้เล่น)</span>
                                                                                            </div>
                                                                                            <div style={{ display: (listitem.status === "5") ? "" : "none" }}>
                                                                                                <span className="-state-text">สถานะ : </span>
                                                                                                <img
                                                                                                    src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                                                                                    className="-ic"
                                                                                                    width="16" height="16"
                                                                                                    alt=""
                                                                                                />
                                                                                                {" "}
                                                                                                <span className="-state-title">ไม่สำเร็จ (โดยระบบ)</span>
                                                                                            </div>
                                                                                            <div style={{ display: (listitem.status === "1") ? "" : "none" }}>
                                                                                                <span className="-state-text">สถานะ : </span>
                                                                                                <img
                                                                                                    src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_success.png"
                                                                                                    className="-ic"
                                                                                                    width="16" height="16"
                                                                                                    alt=""
                                                                                                />
                                                                                                {" "}
                                                                                                <span className="-state-title">สำเร็จ</span>
                                                                                            </div>
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                <div data-v-0bcfa847="" className="list-item__expected">
                                                                                    <div data-v-0bcfa847="" className="currency">
                                                                                        <span data-v-0bcfa847="">
                                                                                            <span
                                                                                                className={"font-digits text-danger"}
                                                                                                style={{ color: "rgb(255, 255, 255)", fontSize: 22 }}
                                                                                            >
                                                                                                {listitem.credit}
                                                                                            </span>
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        );

    }
}
export default App;
